import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import { keyframes } from '@instructure/emotion';
var contentAnimation = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }"])));
var generateStyle = function generateStyle(componentTheme, props) {
  var contentCellStyles = {
    borderBottomColor: componentTheme.contentCellBorderColor,
    paddingLeft: '0.35rem',
    paddingRight: '0.35rem'
  };
  return {
    content: {
      opacity: '0.01',
      transform: 'translate3d(0, 0, 0)',
      animationName: contentAnimation,
      animationFillMode: 'forwards',
      animationDuration: '0.3s',
      th: contentCellStyles,
      td: contentCellStyles
    },
    bar: {
      background: componentTheme.barBackgroundColor,
      transition: componentTheme.barTransition,
      position: 'relative',
      minWidth: componentTheme.barMinWidth,
      height: '100%'
    },
    barCorrect: {
      background: componentTheme.answerRowCorrectBarBackgroundColor
    }
  };
};
export default generateStyle;